import { render, staticRenderFns } from "./JourneyEditContainer.vue?vue&type=template&id=62da00b9"
import script from "./JourneyEditContainer.vue?vue&type=script&lang=js"
export * from "./JourneyEditContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports